/** Modulo Turma (20) — codigos em contracts/enums.yaml */
export const TURMA_ACAO = {
  CRIAR: 201,
  ATUALIZAR: 202,
  REMOVER: 203,
} as const;

export const TURMA_ACOES_MODULO = [
  TURMA_ACAO.CRIAR,
  TURMA_ACAO.ATUALIZAR,
  TURMA_ACAO.REMOVER,
] as const;
